export const ADD_FILTER = 'filter/addFilter'